"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../../context");
const Text_1 = tslib_1.__importDefault(require("../../../../ui-lib/Buttons/Text"));
const ErrorBoundary_1 = require("../../../ErrorBoundary");
const LevelPip_1 = tslib_1.__importDefault(require("../../../../ui-lib/LevelPip"));
const useAudioLevels_1 = tslib_1.__importDefault(require("../../Hooks/useAudioLevels"));
const pipLevelIds = {
    low: "test-mic-level-low",
    mid: "test-mic-level-mid",
    midHigh: "test-mic-level-mid-high",
    high: "test-mic-level-high",
};
const ModularTestMicButton = (0, mobx_react_lite_1.observer)(({ active, children, classes, label = "Test Sound", onClick, ...props }) => {
    var _a, _b;
    /**
     * Component Name (for error msg)
     */
    const componentName = "<TestMicButton/>";
    /**
     * Access EncoderUiContext & destructure API state
     */
    const ctx = (0, react_1.useContext)(context_1.EncoderUiContext);
    (0, useAudioLevels_1.default)({
        mediaStream: ctx === null || ctx === void 0 ? void 0 : ctx.mediaStreamController.source,
        computeLevels: (_a = ctx === null || ctx === void 0 ? void 0 : ctx.testMic) !== null && _a !== void 0 ? _a : false,
        elementIds: pipLevelIds,
    });
    /**
     * Throw error (and trigger ErrorBoundary) if store is undefined.
     * */
    (0, ErrorBoundary_1.useUndefinedStoreError)((ctx === null || ctx === void 0 ? void 0 : ctx.mediaStreamController) != null && ctx.videoElement != null, componentName);
    /**
     * @todo: move this over to our ui-state.
     */
    const toggleMic = () => {
        ctx.testMic = !ctx.testMic;
    };
    /**
     * handleClick function wrapped in global Error handler (to trigger ErrorBoundary).
     * */
    const handleClick = onClick || (0, ErrorBoundary_1.useUIEventError)(toggleMic, componentName);
    /**
     * Stop testing mic when component unmounts.
     * */
    (0, react_1.useEffect)(() => () => {
        if (ctx != null) {
            ctx.testMic = false;
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return (react_1.default.createElement(Text_1.default, { classNames: "video-button--get-sound lv-button--get-sound", "data-selenium": "test-mic-button", label: label, classes: {
            root: {
                minHeight: 43,
                display: "flex",
                gap: "0.375rem",
                alignItems: "center",
                padding: "0.5rem 0.75rem",
                ...((_b = classes === null || classes === void 0 ? void 0 : classes.root) !== null && _b !== void 0 ? _b : {}),
            },
        }, onClick: handleClick, ...props },
        react_1.default.createElement("div", { style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                gap: "0.15rem",
                alignSelf: "center",
            } },
            react_1.default.createElement(LevelPip_1.default, { id: pipLevelIds.low }),
            react_1.default.createElement(LevelPip_1.default, { id: pipLevelIds.mid }),
            react_1.default.createElement(LevelPip_1.default, { id: pipLevelIds.midHigh }),
            react_1.default.createElement(LevelPip_1.default, { id: pipLevelIds.high })), children !== null && children !== void 0 ? children : (ctx.testMic ? "Testing" : "Test")));
});
// eslint-disable-next-line react/function-component-definition
const TestMicButtonWithErrorBoundary = ({ label = "Test Sounds", buttonText, classes, ...props }) => {
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => (react_1.default.createElement(Text_1.default, { classNames: "video-button--get-sound lv-button--get-sound", "data-selenium": "test-mic-button", onClick: undefined, disabled: true, label: label, ...props }, buttonText !== null && buttonText !== void 0 ? buttonText : "Test Unavailable")) },
        react_1.default.createElement(ModularTestMicButton, { label: label, classes: classes, ...props })));
};
exports.default = TestMicButtonWithErrorBoundary;
//# sourceMappingURL=TestMic.js.map